'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _components2 = require('components');

var _selectors = require('selectors');

var mapStateToProps = function mapStateToProps(state) {
    return {
        requiredApiCalls: [state.apiCalls.requirementData, state.apiCalls.customersData, state.apiCalls.bookingMetaData, state.apiCalls.primaryCustomerData],
        passengersById: (0, _selectors.getCustomersById)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_components2.Passenger);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/containers/Passenger.js
// module id = 1356
// module chunks = 0